// Planches « lieux » (couvertures dessinées) : en mode sombre, la version sombre du même fichier est servie
// (suffixe -sombre avant .jpg, téléversée par tools/visuels-lieux/publier.mjs). Dans les cartes-lignes, la vignette carrée (-vignette).
const RE = /(\/planche-[a-z0-9-]+?)(-vignette)?(-sombre)?\.jpg/g;

export default function planches() {
    const html = document.documentElement;
    const systeme = matchMedia("(prefers-color-scheme: dark)");
    const sombre = () => (html.dataset.theme || (systeme.matches ? "dark" : "light")) === "dark";

    function appliquer() {
        const nuit = sombre() ? "-sombre" : "";
        document.querySelectorAll('img[src*="/planche-"], img[srcset*="/planche-"]').forEach((img) => {
            const vignette = img.closest(".card.row") ? "-vignette" : "";
            for (const attr of ["src", "srcset"]) {
                const v = img.getAttribute(attr);
                if (v) img.setAttribute(attr, v.replace(RE, (m, base) => `${base}${vignette}${nuit}.jpg`));
            }
        });
    }

    appliquer();
    new MutationObserver(appliquer).observe(html, { attributes: true, attributeFilter: ["data-theme"] });
    systeme.addEventListener("change", appliquer);
}
